import Grid from '@mui/material/Grid'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { Handler } from 'shared/helpers/typeHelper'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { CLOUDTRUCKS_SUCCESS_MOBILE } from 'helpers/constants'

interface MaxAttemptsProps {
  redirectToSignIn: Handler
}

export function MaxAttempts({ redirectToSignIn }: MaxAttemptsProps) {
  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item md={8} xs={12}>
        <TextV2 type={TYPOGRAPHY.header1} className="text-error-d1 text-center">
          Maximum attempts exceeded
        </TextV2>
      </Grid>
      <Grid item lg={9} xs={11}>
        <TextV2 type={TYPOGRAPHY.paragraph1} className="text-center">
          Please edit your contact information or call CloudTrucks Customer service at{' '}
          {CLOUDTRUCKS_SUCCESS_MOBILE}
        </TextV2>
      </Grid>
      <Grid item lg={6} xs={12}>
        <Box mt={3} />
        <Button onClick={redirectToSignIn} margin="0 auto">
          Return to home page
        </Button>
      </Grid>
    </Grid>
  )
}
